import React from "react";
import { View } from "react-native";

import EPGChannelColumn from "$src/core/components/organisms/EPGChannelGrid/EPGChannelColumn/EPGChannelColumn";
import type { EPGChannelPageProps } from "$src/core/components/organisms/EPGChannelGrid/types";

const EPGChannelPage = ({
  channel,
  columnWidth,
  outerHeight,
  pageWidth,
  pageGutter,
  preferredFocusChannelId,
  preferredFocusProgramIndex,
  compactRowHeight,
  liveRowHeight,
  timelineScrollAnchor,
  programListRemountKey,
  highlightLivePrograms,
  nowMs,
  onTVProgramsFocus,
  onTVProgramNavigateToDetail,
  onTVEpgProgramFocus,
  registerProgramRef,
  onProgramFocus,
}: EPGChannelPageProps) => (
  <View
    style={{
      width: pageWidth,
      height: outerHeight,
      minHeight: outerHeight,
      paddingHorizontal: pageGutter,
    }}
  >
    <EPGChannelColumn
      channel={channel}
      columnWidth={columnWidth}
      preferredFocusChannelId={preferredFocusChannelId}
      preferredFocusProgramIndex={preferredFocusProgramIndex}
      compactRowHeight={compactRowHeight}
      liveRowHeight={liveRowHeight}
      timelineScrollAnchor={timelineScrollAnchor}
      programListRemountKey={programListRemountKey}
      highlightLivePrograms={highlightLivePrograms}
      nowMs={nowMs}
      onTVProgramsFocus={onTVProgramsFocus}
      onTVProgramNavigateToDetail={onTVProgramNavigateToDetail}
      onTVEpgProgramFocus={onTVEpgProgramFocus}
      registerProgramRef={registerProgramRef}
      onProgramFocus={onProgramFocus}
    />
  </View>
);

export default EPGChannelPage;
